import React, { Component } from 'react';
import { CURRENCY, FORMAT_NUMBER, json, Modules, priceDecimalPrecision, Granel, Envasados, isEntregaCilindro, isTipoConvenio, isCilindrosVaciosDevueltos } from '../../../libs/utils/Const';
import { ToolTip } from '../..';
import { formatNumber, isMarketingDocument, isMarketingDocumentSAP } from '../../../libs/utils/GlobalFunc';

class MarketingTable extends Component {




    render() {
        const { type } = this.props;
        return (
            <>
                {type === 'HEAD' ? (
                    this.MarketingHeader()
                ) : (
                    this.MarketingBody()
                )}
            </>
        );
    }

    MarketingHeader = () => {
        const { newOrderModel, action, view, ShowBatchDefinitionModal } = this.props;
        const { isSelectTo } = newOrderModel;
        let newView = newOrderModel?.newView || view;
        const locationView = ['deliveries']
        const isLocationView = locationView?.includes(newView ?? '');

        return (
            <tr style={{ textAlign: "center" }}>
                <td className="sticky-column sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    #
                </td>
                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Artículo
                </td>
                <td className="sticky-header" style={{ maxWidth: 800, backgroundColor: '#d2ab24' }}>
                    Descripción
                </td>
                <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                    Almacén
                </td>
                {newOrderModel.isSalesDocument &&
                    <>
                        <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                            UND Med.
                        </td>
                        <td className="sticky-header" style={{ minWidth: 120, backgroundColor: '#d2ab24' }}>
                            Cant. Galones
                        </td>
                        <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                            Precio Galones
                        </td>
                        <td className="sticky-header" style={{ minWidth: 200, backgroundColor: '#d2ab24' }}>
                            Total Galones
                        </td>
                        <td className="sticky-header" style={{ minWidth: 120, backgroundColor: '#d2ab24' }}>
                            Densidad
                        </td>
                    </>
                }
                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    {isSelectTo ? 'Cantidad Abierta' : view === 'invoiceBorrador' ? 'Cantidad original' : 'Cantidad'}
                </td>
                {isSelectTo && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Cantidad Cerrada
                </td>}
                {isSelectTo && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Cantidad Original
                </td>}
                {view === 'invoiceBorrador' && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Cantidad Abierta
                </td>}
                {view === 'invoiceBorrador' && <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Cantidad Entregada
                </td>}
                {/* CAMPOS DE USUARIO LINE */}
                {json.allItemsUserFields.map((field, index) => {
                    if (field.enabled && field.name && (field.fieldId == isCilindrosVaciosDevueltos || field.fieldId == isEntregaCilindro || field.fieldId == isTipoConvenio)) {
                        return (
                            <td className="sticky-header" id={'userFields' + index} style={{ backgroundColor: '#d2ab24' }}>
                                {field.fieldId === isCilindrosVaciosDevueltos ? 'Cilindros Vacíos Devueltos' : field.name}
                            </td>
                        );
                    }
                })}
                {/* {(isMarketingDocumentSAP(view)) &&
                    <td className="sticky-header" style={{ minWidth: 130, backgroundColor: '#d2ab24' }}>
                        Cilindro
                    </td>
                } */}
                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Código de unidad de medida
                </td>
                {(view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote' || view === 'PurchaseRequest' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') && (
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                        Código UMI
                    </td>)
                }
                {((view === 'quotations' || view === 'invoice' || view === 'creditNote' || view === 'orderSales' || view === 'deliveries' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || view === 'invoiceAuthorization' || view === 'invoiceBorrador' || view === 'invoiceReserve') && (
                    <td className="sticky-header" style={{ minWidth: 80, backgroundColor: '#d2ab24' }}>
                        Disponible
                    </td>))
                }
                {<td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    C. Suministrada
                </td>}
                <td className="sticky-header" style={{ width: 130, backgroundColor: '#d2ab24' }}>
                    Precio
                </td>
                <td className="sticky-header" style={{ minWidth: 115, backgroundColor: '#d2ab24' }}>
                    %Desc
                </td>
                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Total
                </td>
                {view !== 'PurchaseRequest' && Modules.CostCenter && <>
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                        CANAL
                    </td>
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                        SEDES
                    </td>
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                        SUCURSAL
                    </td>
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                        NEGOCIO
                    </td>
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150, }}>
                        CECO
                    </td>
                </>}
                <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 150 }}>
                    Proyecto/Placa
                </td>
                {((view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoiceAuthorization' || view === 'invoiceBorrador' || view === 'invoiceReserve') && (
                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                        Unidad de medida de inventario
                    </td>
                ))}
                <th title='Precio Bruto despues de descuento' className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    P. Bruto despues de descuento
                </th>
                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Indicador I.
                </td>
                <th className="sticky-header" style={{ minWidth: 115, backgroundColor: '#d2ab24' }}> Operación </th>
                <th className="sticky-header" style={{ minWidth: 115, backgroundColor: '#d2ab24' }}> Cod. Afectación </th>
                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Sólo Impuesto
                </td>

                {/* CAMPOS DE USUARIO LINE */}
                {json.allItemsUserFields.map((field, index) => {
                    if (field.enabled && field.name && field.fieldId != isCilindrosVaciosDevueltos && field.fieldId != isEntregaCilindro && field.fieldId != isTipoConvenio) {
                        return (
                            <td className="sticky-header" id={'userFields' + index} style={{ backgroundColor: '#d2ab24' }}>
                                {field.name}
                            </td>
                        );
                    }
                })}
                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                    Sujeto a Impuesto
                </td>

                {action === 2 && view !== 'PurchaseRequest' &&
                    <>
                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                            Ctd.(UM inventario)
                        </td>
                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                            Cantidad en almacén
                        </td>
                    </>
                }
                {isLocationView && (
                    <>
                        <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>Asignación de ubicación</td>
                    </>
                )}
            </tr>
        )
    }
    MarketingBody = () => {
        const {
            newOrderModel
            , action
            , view
            , ShowBatchDefinitionModal
            , editMode
            , _user
            , changeQuantityItem
            , openAlmacen
            , changeAlmacen
            , openPartner
            , ChangeLineVendor
            , specialPrice
            , changePriceInvntItem
            , changeSearchItem
            , openItems
            , returnValueItem
            , changePriceItem
            , validatePriceNull
            , validateCasco
            , changeDiscountItem
            , validateDiscountNull
            , openTaxes
            , openCentroCoste
            , openProjects
            , changeKilosXComprar
            , validateKilosXComprar
            , changePesosXPieza
            , validatePesosXPieza
            , changePrecioXKilo
            , validatePrecioXKilo
            , changeUserFieldsItemsDocument
            , deleteItem
            , operationList
            , igvOperationList
            , changeOperation
            , changeIgvOperation
            , changeUserFieldsDocumentItemUnitMed
            , OpenUomCode
            , ChangeSalUnitMsr
            , changeUserUM
            , changeGalonesCant
            , changeDensidad
            , changeQuantityBlur
            , showDocumentStock
            , showLocationAssignment
        } = this.props;
        let newOrderModelItems = newOrderModel.Items ? newOrderModel.Items : [];
        let newView = newOrderModel?.newView || view;
        let { permissions } = newOrderModel;
        const { isSelectTo } = newOrderModel;
        let isPurchaseQuotation = newOrderModel?.newView === 'PurchaseQuotation' || newOrderModel?.newView === 'PurchaseQuotationDraft';
        let noPurchaseQuotationExists = !isPurchaseQuotation || !newOrderModel.newView;
        const locationView = ['deliveries']
        const isLocationView = locationView?.includes(newView);

        return <>
            {newOrderModelItems.map((item, index) => {
                const whsOnHand = Array.isArray(item?.wareHouseStock) ? (item?.wareHouseStock?.find(({ WhsCode }) => WhsCode === item.WhsCode)?.OnHand || 0) : 0;
                const oneIgvOption = item.U_STR_FECodAfect && !item?.availableIgvOperationList?.length ? igvOperationList.filter(({ Code }) => Code === item.U_STR_FECodAfect) : [];
                return (
                    <tr style={{
                        maxHeight: 10,
                        paddingTop: 8,
                        paddingBottom: 8,
                        color: !item.stock && (view === 'deliveries' || view === 'invoice' || view === 'debitNote' || newView === 'deliveries' || newView === 'invoice' || newView === 'debitNote') ? 'red' : 'black',
                        backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : (newOrderModel.ObjType === '18' && view === 'invoiceAuthorization') ? (!item.BaseLine && item.BaseLine !== 0) ? '#FFD19B' : 'transparent' : 'transparent',
                        opacity: item.isTemporary ? 0.5 : 1,
                        pointerEvents: item.isTemporary ? "none" : "auto",
                    }}
                        title={(newOrderModel.ObjType === '18' && view === 'invoiceAuthorization') ? (!item.BaseLine && item.BaseLine !== 0) ? 'Línea no existente en documento base' : '' : ''}
                        data-toggle={(newOrderModel.ObjType === '18' && view === 'invoiceAuthorization') ? (!item.BaseLine && item.BaseLine !== 0) ? 'tooltip' : '' : ''}

                    >
                        <td className="sticky-column" style={{ background: "#FFF", widht: 150 }}>
                            {index + 1}
                        </td>
                        {/*Artículos*/}
                        <td className="overflow-visible"
                            style={{ backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF' }}>
                            {item.ItemCode}
                        </td>

                        {/*Descripción*/}
                        <td
                            className="overflow-visible"
                            style={{ textAlign: 'center', maxWidth: 800 }}>
                            {item.ItemName}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            <div className='input-group'>
                                {/*Almacen*/}
                                <input
                                    type=" text"
                                    placeholder="Almacén"
                                    className=" form-control validarCant cantBlur btn-outline text-center"
                                    disabled={action === 2 && !editMode ? true : false}
                                    style={{
                                        backgroundColor: item.whsSelected ? 'rgb(248,242,209)' : 'transparent',
                                        color: '#000',
                                        paddingTop: 1,
                                        paddingBottom: 2,
                                    }}
                                    onKeyPress={(eve) => {
                                        if (eve.key === 'Enter') {
                                            openAlmacen(index, 1, item.ItemCode);
                                        }
                                    }}
                                    value={item.WhsCode}
                                    onChange={event => changeAlmacen(index, event)}
                                />
                                {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus) || (action == 2 && editMode && view === 'draft')) && (
                                    <div className="input-group-append" >
                                        <button
                                            type="button"
                                            style={{
                                                backgroundColor: 'transparent',
                                                color: '#EABF28',
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                                border: "1px solid #ced4da"
                                            }}
                                            className="btn btn-outline-secondary"
                                            onClick={() => openAlmacen(index, 1, item.ItemCode)}>
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </td>
                        {newOrderModel.isSalesDocument &&
                            <>
                                {/* UND Med. */}
                                {!Granel?.includes(Number(item?.ItmsGrpCod)) ?
                                    this.emptyField()
                                    :
                                    <>
                                        <td style={{ textAlign: 'center' }}>
                                            <select className="form-control"
                                                disabled={item.ItemNew && (view === 'quotations' || view === 'orderSales' || view === 'draft') ? false
                                                    : (Number(action) !== 1) || (Number(action) === 2 && view !== 'quotations' && view !== 'orderSales' && view === 'draft')}
                                                onChange={event =>
                                                    (Number(action) === 1 || item.ItemNew) &&
                                                    changeUserUM(index, event)
                                                }
                                                value={item.U_RS_UMED || ''} >
                                                <option value={''}> {'Seleccionar'}</option>
                                                <option value={'KGM'}> {'Kilogramos'}</option>
                                                <option value={'GLN'}> {'Galones'}</option>
                                            </select>
                                        </td>
                                    </>
                                }
                                {/* Cant. Galones */}
                                {!Granel?.includes(Number(item?.ItmsGrpCod)) ?
                                    this.emptyField()
                                    :
                                    <>
                                        <td style={{ textAlign: 'center' }}>
                                            <input
                                                type="text"
                                                id={`CANTG-${index}`}
                                                className="form-control btn-outline-secondary"
                                                disabled={(item.U_RS_UMED !== 'GLN' || (Number(action) === 2 && !editMode) || (Number(action) === 2 && view !== 'quotations' && view !== 'orderSales' && view !== 'draft'))}
                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                value={item.U_RS_CANTG || ''}
                                                onChange={event =>
                                                    item.U_RS_UMED === 'GLN' &&
                                                    ((Number(action) === 1 || (Number(action) === 2 && editMode))) &&
                                                    changeGalonesCant(index, event)
                                                }
                                                onBlur={event =>
                                                    item.U_RS_UMED === 'GLN' &&
                                                    ((Number(action) === 1 || (Number(action) === 2 && editMode))) &&
                                                    changeQuantityBlur(index, event, 'U_RS_CANTG')
                                                }
                                            />
                                        </td>
                                    </>
                                }
                                {/* Precio Galones */}
                                {!Granel?.includes(Number(item?.ItmsGrpCod)) ?
                                    this.emptyField()
                                    :
                                    <>
                                        <td style={{ textAlign: 'center' }}>
                                            <input
                                                type="text"
                                                id={`PRECIOGL-${index}`}
                                                className="form-control btn-outline-secondary"
                                                disabled={true} readOnly={true}
                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                value={item.U_RS_PRECIOGL || ''}
                                            />
                                        </td>
                                    </>
                                }
                                {/* Total Galones */}
                                {!Granel?.includes(Number(item?.ItmsGrpCod)) ?
                                    this.emptyField()
                                    :
                                    <>
                                        <td style={{ textAlign: 'center' }}>
                                            <input
                                                type="text"
                                                id={`TOTALGL-${index}`}
                                                className="form-control btn-outline-secondary"
                                                disabled={true} readOnly={true}
                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                value={item.U_RS_TOTALGL || ''}
                                            />
                                        </td>
                                    </>
                                }
                                {/* Densidad */}
                                {!Granel?.includes(Number(item?.ItmsGrpCod)) ?
                                    this.emptyField()
                                    :
                                    <>
                                        <td style={{ textAlign: 'center' }}>
                                            <input
                                                type="text"
                                                id={`DENS-${index}`}
                                                className="form-control btn-outline-secondary"
                                                // disabled={((Number(action) === 2 && !editMode) || (Number(action) === 2 && view !== 'quotations' && view !== 'orderSales' && view !== 'draft'))}
                                                disabled={true} readOnly={true}
                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                value={item.U_RS_DENS || ''}
                                            // onChange={event =>
                                            //     ((Number(action) === 1 || (Number(action) === 2 && editMode))) &&
                                            //     changeDensidad(index, event)
                                            // }
                                            // onBlur={event =>
                                            //     ((Number(action) === 1 || (Number(action) === 2 && editMode))) &&
                                            //     changeQuantityBlur(index, event, 'U_RS_DENS')
                                            // }
                                            />
                                        </td>
                                    </>
                                }
                            </>
                        }
                        {/**CANTIDAD */}
                        <td>
                            <input
                                type="text"
                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                disabled={((action == 2 && !editMode) || ((view === 'quotations' || view === 'orderSales') && item.Gallons)) ? true : (action == 2 && editMode && view == 'draft') ? false : item.LineStatus ? item.LineStatus : !permissions.editItems}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                    paddingTop: 1,
                                    paddingBottom: 2,
                                    width: 100,
                                    textAlign: "center",
                                }}
                                step="any"
                                id={'itemCantidad' + index}
                                value={item.Quantity}
                                onChange={event => changeQuantityItem(event, index)}
                                onBlur={() => specialPrice(index)}
                            />
                        </td>

                        {isSelectTo && <td>
                            <input
                                type=" text"
                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                    paddingTop: 1,
                                    paddingBottom: 2,
                                    maxWidth: 60,
                                    textAlign: "center",

                                }}
                                disabled={true}
                                id={'itemCantidad' + index}
                                value={item.BaseEntry ? item.OriginalQuantityClose : ''}
                            />
                        </td>}

                        {isSelectTo && <td>
                            <input
                                type=" text"
                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                disabled={true}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                    paddingTop: 1,
                                    paddingBottom: 2,
                                    maxWidth: 60,
                                    textAlign: "center",

                                }}
                                id={'itemCantidad' + index}
                                value={item.BaseEntry ? Number.parseFloat(item.OriginalQuantity).toFixed(4) : ''}
                            />
                        </td>}
                        {/* Cantidad abierta */}
                        {view === 'invoiceBorrador' && <td>
                            <input
                                type=" text"
                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                disabled={true}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                    paddingTop: 1,
                                    paddingBottom: 2,
                                    maxWidth: 60,
                                    textAlign: "center",

                                }}
                                id={'itemCantidad' + index}
                                value={item.U_FMB_OpenQty || ''}
                            />
                        </td>}
                        {/* Cantidad entregada */}
                        {view === 'invoiceBorrador' && <td>
                            <input
                                type=" text"
                                className=" form-control validarCant cantBlur btn-outline-secondary"
                                disabled={true}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderColor: '#ced4da',
                                    color: '#000',
                                    paddingTop: 1,
                                    paddingBottom: 2,
                                    maxWidth: 60,
                                    textAlign: "center",

                                }}
                                id={'itemCantidad' + index}
                                value={item.U_FMB_DelivrdQty || ''}
                            />
                        </td>}
                        {/* CAMPOS DE USUARIO LINE */}
                        {json.allItemsUserFields.map((field, indexField) => {

                            if (field.enabled && field.name && (field.fieldId == isCilindrosVaciosDevueltos || field.fieldId == isEntregaCilindro || field.fieldId == isTipoConvenio)) {
                                return (
                                    <td style={{ textAlign: 'right' }}>
                                        {(
                                            Number(field.fieldType) === 1 ?
                                                <input
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000',
                                                        paddingTop: 1,
                                                        paddingBottom: 2,
                                                        minWidth: 100,
                                                        textAlign: "center",
                                                    }}
                                                    className="form-control"
                                                    type="text"
                                                    id={'inputUserField' + 1}
                                                    disabled={(Number(action) === 2 && !editMode) || (field.fieldId === isCilindrosVaciosDevueltos && Granel?.includes(Number(newOrderModel.Items[index].ItmsGrpCod))) ? true : false}
                                                    value={field.name == 'Precio x kilo' ? (returnValueItem(field.IdValue, index) || item.PrecioKilo) : returnValueItem(field.IdValue, index)}
                                                    onChange={(event) => changeUserFieldsItemsDocument(event, field.IdValue, index, field.fieldId)}


                                                /> :
                                                <select
                                                    className="form-control"
                                                    id={'selectUserField' + 1}
                                                    disabled={((Number(action) === 2 && !editMode) || (field.fieldId === isTipoConvenio && Number(newOrderModel.Items[index].UserFieldsItem.userFields1 || 0) !== 2)) || ((field.fieldId === isEntregaCilindro || field.fieldId === isTipoConvenio) && Granel?.includes(Number(newOrderModel.Items[index].ItmsGrpCod))) ? true : false}
                                                    value={returnValueItem(field.IdValue, index)}
                                                    onChange={(event) => changeUserFieldsItemsDocument(event, field.IdValue, index, field.fieldId)}
                                                >
                                                    {field.options.map((option) => {
                                                        if (option.FldValue != null) {
                                                            return (
                                                                <option value={option.FldValue}>{option.FldValue + ' - ' + option.Descr}</option>
                                                            )
                                                        } else {
                                                            return (<></>)
                                                        }

                                                    })}
                                                </select>
                                        )}
                                    </td>
                                );
                            } else {
                                return (<></>)
                            }
                        })}

                        {/* Cilindro */}
                        {/* {(isMarketingDocumentSAP(view)) &&
                            <td style={{ textAlign: 'right' }}>
                                <select
                                    id={`Cilindro${item.ItemCode}${index}`}
                                    disabled={item.U_FMB_IS_CILINDRO === '1' || (action === 2 && !editMode ? true : false)}
                                    value={item?.Casco || 0}
                                    onChange={(e) => item.U_FMB_IS_CILINDRO !== '1' && validateCasco(e, index, item)}
                                    className="form-control">
                                    <option value={0}> No </option>
                                    <option value={1}> Si </option>
                                </select>
                            </td>
                        } */}

                        {/* Código de unidad de medida */}
                        <td style={{ textAlign: 'center' }}>
                            <div className='input-group'>
                                <input
                                    type=" text"
                                    placeholder="Almacén"
                                    className=" form-control validarCant cantBlur btn-outline text-center"
                                    disabled
                                    value={item.UomCode}
                                />

                                {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus) || (action === 2 && editMode && view === 'draft')) && (item.UomCode !== 'Manual') && (
                                    <div className="input-group-append" >
                                        <button
                                            type="button"
                                            style={{
                                                backgroundColor: 'transparent',
                                                color: '#EABF28',
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                                border: "1px solid #ced4da"
                                            }}
                                            className="btn btn-outline-secondary"
                                            onClick={() => OpenUomCode(index, item.ItemCode)}>
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </td>
                        {/*Código UMI*/}
                        {(view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoice' || view === 'invoiceReserve' || view === 'debitNote' || view === 'return' || view === 'creditNote') && (
                            item.UomCode !== 'Manual' ? <td style={{ textAlign: 'center' }}>
                                {item.SalUnitMsr || ''}
                            </td>
                                :
                                <td style={{ textAlign: 'center' }}>
                                    <input
                                        type=" text"
                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                        disabled={action == 2 && !editMode}
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000',
                                            paddingTop: 1,
                                            paddingBottom: 2,
                                            minWidth: 80,
                                            textAlign: "center",
                                        }}
                                        value={item.SalUnitMsr || ''}
                                        onChange={event => ChangeSalUnitMsr(index, event)}
                                    />
                                </td>
                        )}
                        {(view === 'PurchaseRequest' || view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes') && (
                            <td style={{ textAlign: 'center' }}>
                                {item.BuyUnitMsr || ''}
                            </td>)
                        }


                        {/*U_Disponible*/}
                        {
                            ((view === 'quotations' || view === 'invoice' || view === 'creditNote' || view === 'orderSales' || view === 'deliveries' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || view === 'invoiceAuthorization' || view === 'invoiceBorrador' || view === 'invoiceReserve') && (
                                <td>
                                    <input
                                        type=" text"
                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                        disabled={true}
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000',
                                            paddingTop: 1,
                                            paddingBottom: 2,
                                            // maxWidth: 100,
                                            minWidth: 80,
                                            textAlign: "center",
                                        }}
                                        value={Number.parseFloat(item.OnHand).toFixed(4) || 0}
                                    />
                                </td>))
                        }
                        {(view === 'PurchaseRequest' && noPurchaseQuotationExists) &&
                            <>
                                <td> {/*Proveedor*/}
                                    <div className='input-group'>
                                        <input
                                            className=" form-control text-center"
                                            disabled={action == 2 && !editMode}
                                            value={item.LineVendor}
                                            placeholder="Proveedor"
                                            onKeyDown={(eve) => { if (eve.key === 'Enter') { openPartner(index); } }}
                                            onChange={event => ChangeLineVendor(index, event)} />
                                        {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                            <div className="input-group-append" >
                                                <button type="button" className="btn btn-outline-warning" onClick={() => openPartner(index)}>
                                                    <i className="fa fa-list" />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </td>
                                <td> {/* Cantidad en Almacén*/}
                                    <div className='input-group'>
                                        <input
                                            type="text"
                                            className="form-control text-center"
                                            readOnly
                                            value={formatNumber.new(whsOnHand || 0)} />
                                    </div>
                                </td>
                            </>
                        }
                        {/* C. Suministrada */}
                        {(isMarketingDocument(view) || isMarketingDocumentSAP(view)) &&
                            <td>
                                <input
                                    type=" text"
                                    className=" form-control validarCant cantBlur btn-outline-secondary"
                                    disabled={true}
                                    style={{
                                        backgroundColor: 'transparent',
                                        borderColor: '#ced4da',
                                        color: '#000',
                                        paddingTop: 1,
                                        paddingBottom: 2,
                                        width: 100,
                                        textAlign: "center",
                                    }}
                                    id={'DelivrdQty' + index}
                                    value={parseFloat(item.DelivrdQty) > 0 ? parseFloat(item.DelivrdQty).toFixed(2) : ''}
                                />
                            </td>}



                        {/*PRECIO*/}
                        {view !== 'PurchaseOrder' && view !== 'PurchaseQuotation' && view !== 'GoodsReceipt' && <td style={{ width: 130 }}>
                            {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                view === 'creditNote' ?
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <input
                                                type="number"
                                                min={0}
                                                className="form-control validarCant cantBlur btn-outline-secondary"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    borderColor: '#ced4da',
                                                    color: '#000',
                                                    textAlign: 'right',
                                                    minWidth: '16vh',
                                                }}
                                                id={'itemCantidad' + index}
                                                disabled={!(item?.InvntItem && item.InvntItem === 'N')}
                                                value={item.Price ?? '0.00'}
                                                onChange={event => changePriceInvntItem(event.nativeEvent.target.value, index, false)}
                                                onBlur={event => changePriceInvntItem(event.nativeEvent.target.value, index, true)}
                                            />
                                        </div>
                                    </>
                                    :
                                    <input
                                        type="text"
                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                        // disabled={action == 2 && !editMode  ? true : (view === 'PurchaseOrder' && action == 1 ) ? false : !permissions.editItems }
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000',
                                            paddingTop: 1,
                                            paddingBottom: 2,
                                            width: 130,
                                            textAlign: 'right',
                                        }}
                                        id={'itemCantidad' + index}
                                        disabled={view !== 'purchaseCreditNotes'}
                                        value={
                                            (newOrderModel?.isPurchaseDocument || newOrderModel?.isSalesDocument || isMarketingDocument(newOrderModel?.ObjType))
                                                ? (item.Currency || CURRENCY) + " " + formatNumber.new(item.Price, '', priceDecimalPrecision)
                                                : CURRENCY + " " + formatNumber.new(item.Price, '', priceDecimalPrecision)
                                        }
                                        onChange={event => changePriceItem(event, index)}
                                        onBlur={event => validatePriceNull(index)}
                                    />
                                :
                                <label
                                    style={{
                                        backgroundColor: 'transparent',
                                        borderColor: '#ced4da',
                                        color: '#000',
                                        paddingTop: 1,
                                        paddingBottom: 2,
                                        width: 130,
                                        textAlign: 'right',
                                    }}>
                                    {(newOrderModel?.isPurchaseDocument || newOrderModel?.isSalesDocument || isMarketingDocument(newOrderModel?.ObjType))
                                        ? (item.Currency || CURRENCY) + " " + formatNumber.new(item.Price, '', priceDecimalPrecision)
                                        : CURRENCY + " " + formatNumber.new(item.Price, '', priceDecimalPrecision)
                                    }
                                </label>
                            }
                        </td>}
                        {/*PRECIO ENTRADA DE MERCANCIA */}
                        {view === 'GoodsReceipt' && <td style={{ width: 130 }}>
                            {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                <div className="input-group" style={{
                                    width: 170, flexWrap: 'nowrap',
                                    alignItems: 'center',
                                }}>
                                    <span className="input-group-text left"> {item.Currency ?? newOrderModel.DocCur ?? CURRENCY} </span>

                                    <input
                                        type="text"
                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                        // disabled={action == 2 && !editMode  ? true : (view === 'PurchaseOrder' && action == 1 ) ? false : !permissions.editItems }
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000',
                                            paddingTop: 1,
                                            paddingBottom: 2,
                                            width: 130,
                                            textAlign: 'right',
                                        }}
                                        id={'itemCantidad' + index}
                                        disabled={action == 1 ? false : true}
                                        value={item.Price}
                                        onChange={event => changePriceItem(event, index)}
                                        onBlur={event => validatePriceNull(index)}
                                    />
                                </div>
                                :
                                <label
                                    style={{
                                        backgroundColor: 'transparent',
                                        borderColor: '#ced4da',
                                        color: '#000',
                                        paddingTop: 1,
                                        paddingBottom: 2,
                                        width: 130,
                                        textAlign: 'right',
                                    }}>
                                    {CURRENCY + " " + formatNumber.new(item.Price, '', priceDecimalPrecision)}
                                </label>
                            }
                        </td>}

                        {/*Precio*/}
                        {(view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'purchaseDownPayments' || view === 'invoiceAdvance') && <td style={{ width: 130 }}>
                            {(action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                <div className="input-group" style={{
                                    width: 170, flexWrap: 'nowrap',
                                    alignItems: 'center',
                                }}>
                                    <span className="input-group-text left"> {item.Currency ?? newOrderModel.DocCur ?? CURRENCY} </span>
                                    <input
                                        type=" text"
                                        className=" form-control validarCant cantBlur btn-outline-secondary"
                                        // disabled={action == 2 && !editMode  ? true : (view === 'PurchaseOrder' && action == 1 ) ? false : !permissions.editItems }
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000',
                                            paddingTop: 1,
                                            paddingBottom: 2,
                                            width: 130,
                                            textAlign: 'right',
                                        }}
                                        id={'itemCantidad' + index}
                                        // disabled={true}
                                        value={item.Price}
                                        onChange={event => changePriceItem(event, index)}
                                        onBlur={event => validatePriceNull(index)}
                                    />
                                </div>
                                :
                                <label>{formatNumber.new(item.Price, '', priceDecimalPrecision)} {item.Currency} </label>
                            }
                        </td>}

                        {/*%Descuento*/}
                        <td>
                            <div className='input-group'>
                                <input
                                    maxLength="5"
                                    type="text"
                                    disabled={(action == 2 && !editMode) ? true : (action == 2 && editMode && view == 'draft') ? false : item.LineStatus ? item.LineStatus : !permissions.editDiscountLine}
                                    className=" form-control validar desBlur btn-outline-secondary"
                                    style={{
                                        backgroundColor: 'transparent',
                                        borderColor: '#ced4da',
                                        color: '#000',
                                        paddingTop: 1,
                                        paddingBottom: 2,
                                        widht: 50
                                    }}
                                    id={'iteDescuento' + index}
                                    value={item?.DiscountPercent ?? '0.00'}
                                    onChange={event => changeDiscountItem(event, index)}
                                    onBlur={event => validateDiscountNull(index)}
                                />
                                <div className="input-group-append" >
                                    <i className="fa fa-info-circle"
                                        title={`${_user?.U_Discount || 0}%`}
                                        data-toggle="tooltip"
                                        style={{
                                            backgroundColor: 'transparent',
                                            color: '#EABF28',
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                            marginLeft: 5,
                                            marginTop: 10,
                                        }}
                                        aria-hidden="true" />
                                </div>
                            </div>
                        </td>
                        {/*Total*/}
                        <td style={{ textAlign: 'right' }}>{newOrderModel.DocCur + " " + formatNumber.new(item.Total)}</td>
                        {view !== 'PurchaseRequest' && Modules.CostCenter && <>
                            <td>
                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={item.OcrCode || ""} />

                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension1) && (
                                        <div className="input-group-append" >
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#EABF28',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    border: "1px solid #ced4da"
                                                }}
                                                className="btn btn-outline-secondary"
                                                onClick={() => openCentroCoste(index, 1)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </td>
                            <td>
                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={item.OcrCode2 || ""} />

                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension2) && (
                                        <div className="input-group-append" >
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#EABF28',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    border: "1px solid #ced4da"
                                                }}
                                                className="btn btn-outline-secondary"
                                                onClick={() => openCentroCoste(index, 2)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </td>
                            <td>
                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={item.OcrCode3 || ""} />

                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension3) && (
                                        <div className="input-group-append" >
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#EABF28',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    border: "1px solid #ced4da"
                                                }}
                                                className="btn btn-outline-secondary"
                                                onClick={() => openCentroCoste(index, 3)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </td>
                            <td>
                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={item.OcrCode4 || ""} />

                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension4) && (
                                        <div className="input-group-append" >
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#EABF28',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    border: "1px solid #ced4da"
                                                }}
                                                className="btn btn-outline-secondary"
                                                onClick={() => openCentroCoste(index, 4)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </td>
                            <td>
                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        disabled
                                        readOnly
                                        value={item.OcrCode5 || ""} />

                                    {((action === 1 || (action === 2 && editMode)) && !item.Dimension5) && (
                                        <div className="input-group-append" >
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#EABF28',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                    border: "1px solid #ced4da"
                                                }}
                                                className="btn btn-outline-secondary"
                                                onClick={() => openCentroCoste(index, 5)}>
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </td>
                        </>}
                        {/*Proyecto/Placa*/}
                        <td>
                            <div className="input-group">
                                <input
                                    className="form-control"
                                    disabled
                                    readOnly
                                    value={item.Project || ""} />

                                {(Number(action) === 1 || (Number(action) === 2 && editMode && permissions.editItems && !item.LineStatus)) && (
                                    <div className="input-group-append" >
                                        <button
                                            type="button"
                                            style={{
                                                backgroundColor: 'transparent',
                                                color: '#EABF28',
                                                paddingTop: 2,
                                                paddingBottom: 2,
                                                border: "1px solid #ced4da"
                                            }}
                                            className="btn btn-outline-secondary"
                                            onClick={() => openProjects(index)}>
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </td>
                        {/* Unidad de medida de inventario */}
                        {((view === 'invoice' || view === 'creditNote' || view === 'debitNote' || view === 'quotations' || view === 'orderSales' || view === 'deliveries' || view === 'invoiceAuthorization' || view === 'invoiceBorrador' || view === 'invoiceReserve') && (
                            <td>
                                <select className="form-control"
                                    disabled={(((action === 2 && !editMode) && (Number(item.measureUnit) === 1)) || (action === 1 && (Number(item.measureUnit) === 1))) ? true : false}
                                    onChange={event => changeUserFieldsDocumentItemUnitMed(event, index)}
                                    value={item.UserBaseUn} >
                                    <option value={'N'}> {'No'}</option>
                                    <option value={'Y'}> {'Si'}</option>
                                </select>
                            </td>
                        ))}
                        {/*Precio Bruto despues de descuento*/}
                        <td style={{ textAlign: 'center' }}>
                            {(newOrderModel?.isPurchaseDocument || newOrderModel?.isSalesDocument || isMarketingDocument(newOrderModel?.ObjType)) ?
                                (item.Currency || CURRENCY) + " " + formatNumber.new((item.DiscountedPrice))
                                : CURRENCY + " " + formatNumber.new((item.DiscountedPrice))}
                        </td>
                        {/*Indicador*/}
                        <td style={{ textAlign: 'center' }}>

                            {item?.TaxName?.replace('Percepción', '') || item.TaxCode}
                            {_user?.BranchPermission?.ChangeTaxRate && (action == 1 || (action == 2 && editMode && permissions.editItems && !item.LineStatus) || (action == 2 && editMode && view == 'draft')) &&
                                /*!isMarketingDocument(view) && !isMarketingDocumentSAP(view) &&*/
                                (
                                    <button
                                        type="button"
                                        style={{
                                            backgroundColor: 'transparent',
                                            color: '#EABF28',
                                            paddingTop: 1,
                                            paddingBottom: 2,
                                        }}
                                        className="btn"
                                        onClick={() => openTaxes(index, 'Manual')}>
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                )}
                        </td>
                        {/* Tipo de Operación */}
                        <td className="text-center">
                            <select
                                className="form-control"
                                disabled={action === 2 && !editMode}
                                value={item.U_BPP_OPER || ""}
                                style={{ maxWidth: 100 }}
                                onChange={({ target: { value } }) => changeOperation(index, value)}>
                                {operationList.map((option, subindex) => <option key={`operationList-${index}-${subindex}`} value={option.Code}> {option.Name} </option>)}
                            </select>
                        </td>
                        {/* Código de Afectación IGV */}
                        <td className="text-center">
                            <select
                                className="form-control"
                                disabled={action === 2 && !editMode}
                                value={item.U_STR_FECodAfect || ""}
                                style={{ maxWidth: 120 }}
                                onChange={({ target: { value } }) => changeIgvOperation(index, value)}>
                                <option value={""}> Seleccionar </option>
                                {!!oneIgvOption?.length && oneIgvOption.map((option, subindex) => <option key={`oneIgvOperationList-${index}-${subindex}`} value={option.Code}> {option.Code} - {option.Name} </option>)}
                                {item.availableIgvOperationList.map((option, subindex) => <option key={`igvOperationList-${index}-${subindex}`} value={option.Code}> {option.Code} - {option.Name} </option>)}
                            </select>
                        </td>
                        {/*Sólo Impuesto*/}
                        <td style={{ textAlign: 'center' }}>
                            <input
                                disabled={action === 2 && !editMode ? true : false}
                                type="checkbox"
                                checked={item.TaxOnly === 'Y'}
                                onChange={event => this.changeTaxOnly(event, index)}
                                style={{ marginRight: '8px' }}
                            />
                        </td>


                        {/* Orden, Entrada y Factura de proveedor - Pronto Pago */}
                        {(view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt' || view === 'purchaseInvoice') &&
                            <>
                                <td className="text-center" style={{ width: 130 }}>
                                    <label>{FORMAT_NUMBER.new(item.ItemCode === "DESCUENTO" ? 0 : (Number(item.Price || 0) * item.Quantity * Number(newOrderModel.U_FMB_DescPP || 0) / 100))} {item.Currency}</label>
                                </td>
                            </>
                        }
                        {/*Orden de compra - Entrada de mercancia de proveedor*/}
                        {(view === 'PurchaseOrder' || view === 'PurchaseQuotation' || view === 'GoodsReceipt') &&
                            <>
                                {/*KilosXComprar*/}
                                <td style={{ width: 130 }}>
                                    {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                        <input
                                            type="text"
                                            className="form-control validarCant cantBlur btn-outline-secondary"
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                                paddingTop: 1,
                                                paddingBottom: 2,
                                                width: 130,
                                                textAlign: 'right',
                                            }}
                                            id={'KilosXComprar' + index}
                                            value={item.KilosXComprar ?? 0}
                                            onChange={event => changeKilosXComprar(event, index)}
                                            onBlur={() => validateKilosXComprar(index)}
                                        /> :
                                        <label>{item.KilosXComprar ? parseFloat(item.KilosXComprar).toFixed(3) : "0"} KG</label>
                                    }
                                </td>

                                {/*PesosXPieza*/}
                                <td style={{ width: 130 }}>
                                    {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                        <input
                                            type="text"
                                            className="form-control validarCant cantBlur btn-outline-secondary"
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                                paddingTop: 1,
                                                paddingBottom: 2,
                                                width: 130,
                                                textAlign: 'right',
                                            }}
                                            id={'PesosXPieza' + index}
                                            value={item.PesosXPieza ?? 0}
                                            onChange={event => changePesosXPieza(event, index)}
                                            onBlur={() => validatePesosXPieza(index)}
                                        /> :
                                        <label>{formatNumber.new(item.PesosXPieza ?? '0')}</label>
                                    }
                                </td>

                                {/*PrecioXKilo*/}
                                <td style={{ width: 130 }}>
                                    {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) ?
                                        <input
                                            type="text"
                                            className="form-control validarCant cantBlur btn-outline-secondary"
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                                paddingTop: 1,
                                                paddingBottom: 2,
                                                width: 130,
                                                textAlign: 'right',
                                            }}
                                            id={'PrecioXKilo' + index}
                                            value={item.PrecioXKilo ?? 0}
                                            onChange={event => changePrecioXKilo(event, index)}
                                            onBlur={() => validatePrecioXKilo(index)}
                                        /> :
                                        <label>{CURRENCY + formatNumber.new(item.PrecioXKilo ?? '0')}</label>
                                    }
                                </td>
                            </>}

                        {/* CAMPOS DE USUARIO LINE */}
                        {json.allItemsUserFields.map((field, indexField) => {
                            if (field.enabled && field.name && field.fieldId != isCilindrosVaciosDevueltos && field.fieldId != isEntregaCilindro && field.fieldId != isTipoConvenio) {
                                return (
                                    <td style={{ textAlign: 'right' }}>
                                        {(
                                            Number(field.fieldType) === 1 ?
                                                <input
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000',
                                                        paddingTop: 1,
                                                        paddingBottom: 2,
                                                        minWidth: 100,
                                                        textAlign: "center",
                                                    }}
                                                    className="form-control"
                                                    type="text"
                                                    id={'inputUserField' + 1}
                                                    disabled={(Number(action) === 2 && !editMode) ? true : false}
                                                    value={field.name == 'Precio x kilo' ? (returnValueItem(field.IdValue, index) || item.PrecioKilo) : returnValueItem(field.IdValue, index)}
                                                    onChange={(event) => changeUserFieldsItemsDocument(event, field.IdValue, index, field.fieldId)}


                                                /> :
                                                <select
                                                    className="form-control"
                                                    id={'selectUserField' + 1}
                                                    disabled={(Number(action) === 2 && !editMode) ? true : false}
                                                    value={returnValueItem(field.IdValue, index)}
                                                    onChange={(event) => changeUserFieldsItemsDocument(event, field.IdValue, index, field.fieldId)}
                                                >
                                                    {field.options.map((option) => {
                                                        // if (field.name === "Tipo de Operacion" && item.TaxCode === 'IGV') {
                                                        //     if (option.Descr === "VENTA NACIONAL" || option.FldValue === '-' || option.FldValue === '') {
                                                        //         return (
                                                        //             <option value={option.FldValue}>{option.FldValue + ' - ' + option.Descr}</option>
                                                        //         )
                                                        //     }
                                                        // } else {
                                                        if (option.FldValue != null) {
                                                            return (
                                                                <option value={option.FldValue}>{option.FldValue + ' - ' + option.Descr}</option>
                                                            )
                                                        } else {
                                                            return (<></>)
                                                        }
                                                        // }
                                                    })}
                                                </select>
                                        )}
                                    </td>
                                );
                            } else {
                                return (<></>)
                            }
                        })}

                        {/*Sólo Impuesto*/}
                        <td>
                            <div className="input-group">
                                <select
                                    disabled={action === 2 && !editMode ? true : false}
                                    value={item.TaxStatus || 'N'}
                                    onChange={event => this.changeTaxStatus(event, index)}
                                    className="form-control">
                                    {item.TaxCode === 'EXO' ?
                                        <>
                                            <option value="N">No</option>
                                        </>
                                        :
                                        <>
                                            <option value="Y">Sí</option>
                                            <option value="N">No</option>
                                        </>
                                    }
                                </select>
                            </div>
                        </td>

                        {action === 2 && view !== 'PurchaseRequest' &&
                            <>
                                {/* Ctd.(UM inventario) */}
                                <td style={{ textAlign: 'center' }}>
                                    <label>{item.InvQty ? formatNumber.new(item.InvQty || 0) : ''} </label>
                                </td>
                                {/* Cantidad en almacén */}
                                <td style={{ textAlign: 'center' }}>
                                    <label>{item.OpenCreQty ? formatNumber.new(item.OpenCreQty || 0) : ''} </label>
                                </td>
                            </>
                        }

                        {isLocationView && (
                            <>
                                {/* Asignación de ubicación */}
                                <td>
                                    <div className="input-group">
                                        {item.BinActivat === 'Y' &&
                                            <>
                                                <input
                                                    className={`form-control text-right ${action === 1 && Number(item.Quantity) !== Number(item.TotalAsigned) ? "text-danger" : ""}`}
                                                    disabled
                                                    readOnly
                                                    value={item.Quantity || ""}
                                                />
                                                {(action === 1 || action === 2) && (
                                                    <div className="input-group-append" >
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                color: '#EABF28',
                                                                paddingTop: 2,
                                                                paddingBottom: 2,
                                                                border: "1px solid #ced4da"
                                                            }}
                                                            className="btn btn-outline-secondary"
                                                            onClick={() => action === 2 ? showDocumentStock(item.LineNum) : showLocationAssignment(item.LineNum, 1)}
                                                        >
                                                            <i className="fa fa-list" aria-hidden="true" />
                                                        </button>
                                                    </div>
                                                )}
                                            </>
                                        }
                                    </div>
                                </td>
                            </>
                        )}

                        {noPurchaseQuotationExists &&
                            <td
                                className="sticky-columns"
                                style={{
                                    backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF',
                                    textAlign: 'center'
                                }}>
                                {/*Eliminar*/}
                                {(action === 1 || (action === 2 && editMode && permissions.editItems && !item.LineStatus)) && !item.isTemporary && (
                                    <button
                                        disabled={item.U_FMB_IS_CILINDRO === '1'}
                                        type="button"
                                        style={{
                                            backgroundColor: 'transparent',
                                            padding: 5,
                                            color: '#c42222',
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                        }}
                                        className="btn"
                                        onClick={() => deleteItem(index)}>
                                        <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                    </button>
                                )}
                            </td>
                        }

                    </tr>
                );
            })}

            {noPurchaseQuotationExists &&
                <tr>
                    <td></td>
                    <td className="sticky-column"
                        style={{ backgroundColor: '#FFF', textAlign: 'center' }}>


                        {(action == 1 || (action == 2 && editMode && permissions.editItems)) && (

                            <div>
                                <input
                                    type=" text"
                                    placeholder="Artículo"
                                    className=" form-control validarCant cantBlur btn-outline-secondary"
                                    // disabled={(action == 2 && !editMode) ? true : item.LineStatus ? item.LineStatus : !permissions.editItems}
                                    style={{
                                        backgroundColor: 'transparent',
                                        color: '#000',
                                        paddingTop: 1,
                                        paddingBottom: 2,
                                    }}
                                    onKeyPress={(ev) => {
                                        if (ev.key === 'Enter') {
                                            openItems();
                                        }
                                    }}
                                    value={newOrderModel.searchItem || ''}
                                    onChange={event => changeSearchItem(event)}
                                // onBlur={event => specialPrice(index)}
                                />
                                <button
                                    type="button"
                                    style={{
                                        backgroundColor: 'transparent',
                                        padding: 5,
                                        color: 'green',
                                        paddingTop: 2,
                                        paddingBottom: 2,
                                    }}
                                    className="btn"
                                    onClick={() => openItems()}>
                                    <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                </button>
                            </div>
                        )}
                    </td>
                </tr>
            }
        </>
    }

    changeTaxOnly = async (event, index) => {
        const { newOrderModel, refreshTotal } = this.props;
        newOrderModel.Items[index].TaxOnly = event.nativeEvent.target.checked === true ? 'Y' : 'N';
        setTimeout(() => {
            refreshTotal(newOrderModel, index);
        }, 100);
    }
    changeTaxStatus = async (event, index) => {
        const { newOrderModel, refreshTotal } = this.props;
        newOrderModel.Items[index].TaxStatus = event.nativeEvent.target.value;
        setTimeout(() => {
            refreshTotal(newOrderModel, index);
        }, 100);
    }

    emptyField = () => {
        return (
            <td style={{ textAlign: 'center' }}>
                <input
                    type="text"
                    className="form-control btn-outline-secondary"
                    disabled={true}
                    readOnly={true}
                    style={{
                        backgroundColor: 'transparent',
                        borderColor: '#ced4da',
                        color: '#000',
                        paddingTop: 1,
                        paddingBottom: 2,
                        minWidth: 80,
                        textAlign: "center",
                    }}
                    value={''}
                />
            </td>
        )
    }


}

export default MarketingTable;
